<template>
  <div class="info item-component">
    <Cell v-for="(col, fld) in fields" :name=fld :item=item :field=col :key=fld />
  </div>
</template>

<script>
  import Cell from './Cell'
  export default {
    components: {Cell},
    name: 'Item',
    props: ['fields', 'item', 'url'],
  }
</script>

<style lang="scss">
  div.info.item-component {
    display: table;
    &:not(.inline) {
      width: 100%;
    }
    dl {
      display: table-row;
      > dd, > dt {
        display: table-cell;
        padding: 4px;
      }
      > dt {
        font-weight: 400;
        text-align: left;
        &::after {
          content: none;
        }
      }
      > dd {
        font-weight: 700;
        text-align: right;
      }
    }
    &.striped {
      dl:nth-child(odd) {
        &, > dd, > dt {
          background: $body-bg;
        }
      }
    }
    &.inline {
      display: inline-table;
      dl {
        > dt {
          padding-left: 0;
          &::after {
            content: ': ';
          }
        }
        > dd {
          padding-right: 0;
          text-align: left;
        }
      }
    }
    &.inverse {
      dl {
        > dt {
          font-weight: 600;
        }
        > dd {
          font-weight: 400;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/display/Item.vue